"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Ganymede = undefined;

var _ice = require("ice");

var _Exceptions = require("../AuthExceptions/Exceptions");

var _Ganymede = require("../Ganymede/Ganymede");

// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************
//
// Ice version 3.7.0
//
// <auto-generated>
//
// Generated from file `Ganymede/Glacier.ice'
//
// Warning: do not edit this file.
//
// </auto-generated>
//

const _ModuleRegistry = _ice.Ice._ModuleRegistry;
const Slice = _ice.Ice.Slice;

Object.defineProperty(_Ganymede.Ganymede, 'DomainContextKey', {
    value: "domain"
});

const iceC_Ganymede_UserSession_ids = ["::Ganymede::UserSession", "::Glacier2::Session", "::Ice::Object"];

/**
 * Glacier session for users.
 **/
_Ganymede.Ganymede.UserSession = class extends _ice.Ice.Object {
    static get _iceImplements() {
        return [_ice.Glacier2.Session];
    }
};

_Ganymede.Ganymede.UserSessionPrx = class extends _ice.Ice.ObjectPrx {
    static get _implements() {
        return [_ice.Glacier2.SessionPrx];
    }
};

Slice.defineOperations(_Ganymede.Ganymede.UserSession, _Ganymede.Ganymede.UserSessionPrx, iceC_Ganymede_UserSession_ids, 0, {
    "getToken": [, 2, 2,, [7],,,,,],
    "refreshToken": [,,,, [7],,, [_Exceptions.AuthExceptions.InvalidToken],,],
    "getExpiresAt": [, 2, 2,, [4],,,,,],
    "logout": [,,,,,,,,,]
});
exports.Ganymede = _Ganymede.Ganymede;


//////////////////
// WEBPACK FOOTER
// ./~/@slices/Ganymede/Glacier.js
// module id = 466
// module chunks = 0